export enum GameVariant {
    FANDUEL = 'fanduel',
    INCENTIVE_GAMES = 'incentiveGames'
}

export interface ISymbol {
    collectionType: string;
    amount: number;
    targetAmount: number;
    prizes: { prizeCode: string }[];
}

export interface IgPlayDay {
    selnNumber: number; // day index starting at 1
    revealTime: number; // timestamp
    expiryTime: number; // timestamp
    revealed: boolean;
    revealedTime: number; // timestamp
    totalSpins: number;
    maxSpins: number;
}

export interface IgEntryData {
    gameId: number;
    gameType: string;
    receipt: string;
    collections: ISymbol[];
    selections: IgPlayDay[];
}

export interface PlayDay {
    selnNumber: number;
    freeSpins: number;
}

export interface BonusDraw {
    tickets: number;
    closeTime: number;
}

export interface EntryData {
    collections: ISymbol[];
    currentDay: PlayDay;
    playedDays: number[];
    bonusDraw: BonusDraw;
    error: string | Error | boolean | null;
    status?: number;
}

type RewardsMachineImage = {
    id: string;
    url: string;
};

type RewardsMachineData = {
    bonusDrawType: string;
    bonusDrawText: Array<{
        type: string;
        text: string;
        direction: string;
    }>;
    bonus: string;
    bannerType: string;
    igSpecificParams: string;
    rewardsMachineTheme: {
        iconsRewardsMachineInfo: Array<{
            icon: Record<string, any>;
        }>;
        theme: string;
        bannerLoggedOut: RewardsMachineImage;
        bannerNoSpins: RewardsMachineImage;
        bannerSpinsAvailable: RewardsMachineImage;
        welcomeHeaderBonusDraw: RewardsMachineImage;
        welcomeHeaderDefaultBonusDraw: RewardsMachineImage;
        welcomeHeaderTrainingBonusDraw: RewardsMachineImage;
    };
    exitScreenBackground: RewardsMachineImage;
    gameDetailsBackground: RewardsMachineImage;
    rewardsMachineLogo: RewardsMachineImage;
    rewardsMachineTrainingBonusDrawLogo: RewardsMachineImage;
    level: number;
    levelName: string;
};

export type RewardsMachineContent = {
    success: boolean;
    data: RewardsMachineData;
};

export interface RewardsMachineComponentsResponse {
    rewardsMachine: RewardsMachineContent;
}

export type RewardsMachineState = {
    entry: EntryData | null;
    welcome: boolean;
    error: boolean;
    rmLoadingCompleted: boolean;
};
